import React from "react";

const Experience = () => {
  const isDarkMode = document.body.classList.contains("dark");

  return (
    <div
      className={`min-h-screen flex flex-col justify-start items-center p-8 ${
        isDarkMode ? "bg-[#111827] text-white" : "bg-white text-gray-900"
      }`}
      style={{ overflow: "hidden" }}
    >
      <div className="container mx-auto px-6 md:px-12">
        {/* Title */}
        <h1 className="text-5xl font-bold text-center mb-16">Experience</h1>

        {/* Timeline Container */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="absolute border-l-4 border-blue-500 left-1/2 transform -translate-x-1/2 h-full"></div>

         {/* Front-End Experience Block */}
<div className="relative flex items-start mb-12 justify-center">
  {/* Date on Top */}
  <div className="absolute bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold text-center -top-6 left-1/2 transform -translate-x-1/2 shadow-lg">
    2022 – Present
  </div>

  {/* Content Box */}
  <div className="bg-white dark:bg-gray-800 shadow-xl p-6 rounded-lg mt-8 transition-transform hover:scale-105 max-w-xl">
    <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">
      Front-End Developer
    </h2>

    <p className="text-blue-600 dark:text-blue-300 font-medium">
      Training & Projects Experience
    </p>

    <ul className="list-disc ml-6 mt-3 text-gray-600 dark:text-gray-400 leading-relaxed">
      <li>
        Built responsive and modern user interfaces using HTML, CSS, and Sass.
      </li>
      <li>
        Developed interactive web applications using JavaScript (ES6+) and
        TypeScript.
      </li>
      <li>
        Created reusable components and SPAs using React.
      </li>
      <li>
        Worked with Next.js for routing, performance, and SEO optimization.
      </li>
      <li>
        Styled applications using Bootstrap and Tailwind CSS.
      </li>
      <li>
        Used Git and GitHub for version control and project management.
      </li>
    </ul>
  </div>
</div>

        </div>
      </div>
    </div>
  );
};

export default Experience;
